const aux = (props) => {
  return props.children;
};

export default aux;



// WEBPACK FOOTER //
// ./src/Components/HOC/Auxil.js